import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHOC } from '../../../components'
import * as PrintHelpers from '../../../components/prints/utils'
class VoucherPrintReport extends React.Component {
  render() {
    let { ticket, voucher, children } = this.props
    const { organization, customer, terms } = ticket
    return (
      <ReactBootstrap.Row className="mb-5  print_zone">
        <ReactBootstrap.Col xs="12" className="p-0 mb-2 text-end d-print-none">
          <span className="pr-3">{children}</span>
        </ReactBootstrap.Col>
        <div className="pl-5 pr-5">
          <ReactBootstrap.Col xs={12}>
            <PrintHelpers.Header legend="Voucher" organization={organization} />
            <div className="text-center">
              <strong> {voucher.is_cancelled ? 'REFUND' : 'RECEIPT'} </strong>
            </div>
          </ReactBootstrap.Col>
          <ReactBootstrap.Row>
            <ReactBootstrap.Col xs={6}>
              <PrintHelpers.EaseOnBarcode value={voucher.reference_number} />
            </ReactBootstrap.Col>

            <ReactBootstrap.Col className="text-end" xs={6}>
              <PrintHelpers.InlineText
                label="Inward Reference Number"
                lineBreakAfterLabel={true}
                value={ticket.reference_number}
              />
              {!voucher.display_created_at ? (
                <PrintHelpers.TimeStamp
                  label="Created On"
                  value={voucher.created_at}
                />
              ) : (
                <PrintHelpers.TimeStamp
                  label="Created On"
                  value={voucher.display_created_at}
                />
              )}
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
          <ReactBootstrap.Col xs={12}>
            {voucher.is_cancelled && (
              <ReactBootstrap.Alert variant="danger">
                {voucher.cancel_reason ||"This Voucher has been cancelled."}
              </ReactBootstrap.Alert>
            )}{' '}
          </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={12}>
            <p style={{ lineHeight: '25px' }}>
              Received with thanks from Mr./Mrs./Miss
              <strong className="ps-2 pe-2">
                {customer.first_name} {customer.last_name}
              </strong>
              a sum of
              <strong className="ps-2 pe-2">
                <PrintHelpers.Currency value={voucher.total_amount} />
              </strong>
              by
              <strong className="ps-2 pe-2">
                {voucher.actual_payment_modes.join(', ')}
              </strong>
              in favour of <strong> {organization.name} &nbsp; </strong>
              towards
              <strong className="ps-2 pe-2">{voucher.towards}</strong>
            </p>
            {voucher && voucher.online_payment_reference_number && (
              <p>
                <PrintHelpers.InlineText
                  label="Online Payment Reference Number"
                  lineBreakAfterLabel={true}
                  value={voucher.online_payment_reference_number}
                />
              </p>
            )}
          </ReactBootstrap.Col>
          {voucher.note && (
            <ReactBootstrap.Col xs={12}>
              <p>
                <strong>Note :</strong>
                {voucher.note}
              </p>
            </ReactBootstrap.Col>
          )}
           {voucher.refund_amount > 0 ? (

              <p> <strong className=" pe-2">Refund Amount :</strong>   <PrintHelpers.Currency value={voucher.refund_amount} /></p>
              ):<></>
           }
             {voucher.refund_date  ? (

              <p> <strong className=" pe-2">Refund Date :</strong>   {voucher.refund_date}</p>
              ):<></>
           }
             {voucher.utrn_number > 0 ? (

              <p> <strong className=" pe-2">UTRN Number :</strong>   {voucher.utrn_number}</p>
              ):<></>
           }



          <ReactBootstrap.Col xs={12}>
            <PrintHelpers.Terms
              label="Important"
              value={voucher.terms ? voucher.terms : terms}
            />
          </ReactBootstrap.Col>
          <ReactBootstrap.Row>
            <ReactBootstrap.Col className="mt-5  mb-5" xs={6}>
              <div style={{ marginTop: '100px' }}>
                <strong>
                  <PrintHelpers.InlineText value={voucher.created_by} />
                </strong>
              </div>
            </ReactBootstrap.Col>
            <ReactBootstrap.Col className="mt-5 mb-5 text-end" xs={6}>
              <PrintHelpers.Signature signature={voucher.customer_signature2} />
              <strong>
                <PrintHelpers.InlineText value={'Customer Signature'} />
              </strong>
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        </div>
      </ReactBootstrap.Row>
    )
  }
}
export const VoucherPrint = PrintHOC(VoucherPrintReport)
